import { render, staticRenderFns } from "./HouseInput.vue?vue&type=template&id=bbcc2a42&"
import script from "./HouseInput.vue?vue&type=script&lang=js&"
export * from "./HouseInput.vue?vue&type=script&lang=js&"
import style0 from "./HouseInput.vue?vue&type=style&index=0&id=bbcc2a42&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports